function CollapseView({
  stock,
  onCancelRequest,
  onEdit,
  onReceiveModal,
  onReconcile,
  onDelete,
}) {
  return (
    <div className="border p-3 rounded bg-white">
      <div className="mb-3">
        <p className="mb-1">
          <strong>Store:</strong> {stock?.sourceLocation?.name}
        </p>
        <p className="mb-1">
          <strong>Request Number:</strong> {stock?.requestNumber}
        </p>
        <p className="mb-1">
          <strong>Request Date:</strong>{" "}
          {stock?.requestDate &&
            new Date(stock?.requestDate).toLocaleString("en-US", {
              month: "long", // March
              day: "numeric", // 2
              year: "numeric", // 2025
              hour: "numeric", // 5
              minute: "2-digit", // 15
              hour12: true, // am/pm
            })}
        </p>
      </div>

      <div className="d-flex gap-2">
        {![
          "Cancelled",
          "Approved",
          "Dispatched",
          "Pending Partially Received",
          "Pending Fully Received",
          "Disapproved",
          "Completed",
          "Partially Received",
          "For Reconciliation",
        ].includes(stock?.status) && (
          <button
            className="btn btn-success text-white"
            onClick={onCancelRequest}
          >
            <i className="bi bi-pencil-fill me-2"></i> Cancel Request
          </button>
        )}
        {["Dispatched"].includes(stock?.status) && (
          <button
            className="btn btn-success text-white"
            onClick={onReceiveModal}
          >
            <i className="bi bi-pencil-fill me-2"></i> Receive
          </button>
        )}

        {["Disapproved"].includes(stock?.status) && (
          <button className="btn btn-success text-white" onClick={onReconcile}>
            <i className="bi bi-pencil-fill me-2"></i> Ask to Reconcile
          </button>
        )}

        <button
          className="btn text-dark"
          style={{ backgroundColor: "#d1d1d1" }}
          onClick={onEdit}
        >
          <i className="bi bi-eye me-2"></i> View
        </button>
        {/* <button className="btn btn-danger" onClick={onDelete}>
          <i className="bi bi-trash-fill me-2"></i> Delete
        </button> */}
      </div>
    </div>
  );
}

export default CollapseView;
